import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, take, tap } from "rxjs/operators";

import { Store } from "@ngrx/store";
import { LoadTreatments } from "../store/treatment.actions";
import { TreatmentState } from "../store/treatment.reducer";
import { TreatmentModel } from "../models";
import { TreatmentService } from "./treatment.lib.service";
import { NotificationService } from "libs/tm-common/src/lib/services/notification.lib.service";
@Injectable({
	providedIn: 'root'
})
export class TreatmentsResolver {
	private treatmentService = inject(TreatmentService);
	private notificationService = inject(NotificationService);
	private store = inject<Store<TreatmentState>>(Store);


	resolve(
		_route: ActivatedRouteSnapshot,
		_state: RouterStateSnapshot
	): Observable<TreatmentModel[]> {
		return this.treatmentService.getCustomerTreatments().pipe(
			take(1),
			tap((treatments: TreatmentModel[]) =>
				this.store.dispatch(new LoadTreatments({ treatments }))
			),
			catchError(() => {
				this.notificationService.showErrorMessage("ResolveTreatmentsError", "", 5000);
				return of([]); //Open route, even if treatments could not be loaded
			})
		);
	}
}
